import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ProjectsService {
  constructor(private http: HttpClient) {}

  getProjects() {
    return this.http.get('/projects');
  }

  getAttachedProjectsForMsisdn(msisdnId: string) {
    return this.http.get(`/inbound/configuration/numbers/${msisdnId}/projects`);
  }

  attachMsisdnToProject(msisdnId: string, projectId: string) {
    return this.http.post(`/projects/${projectId}/attach`, [msisdnId]);
  }

  detachMsisdnFromProject(msisdnId: string, projectId: string) {
    return this.http.post(`/projects/${projectId}/detach`, { msisdnId });
  }
}
